import angular from 'angular';
import { changePageTitle } from 'auth/actions/session.actions';
import SmsNotificationTemplatesComponent from './components/sms-notification-templates/sms-notification-templates-component';
import ManageLoginSmsNotificationComponent from './components/manage-login-sms-notification/manage-login-sms-notification-component';
import ManageSmsNotificationComponent from './components/manage-sms-notification/manage-sms-notification-component';

export default angular
  .module('sms', [
    'utils',
    SmsNotificationTemplatesComponent.name,
    ManageLoginSmsNotificationComponent.name,
    ManageSmsNotificationComponent.name,
  ])
  .config([
    '$stateProvider',
    function configure($stateProvider) {
      $stateProvider.state('sms-update', {
        parent: 'arw',
        url: '/sms-notifications/templates/:templateId/update/:templateName',
        template: `<sms-notification-edit
                        model="appCtrl.appFactory.model"
                        namespace="notificationTemplates"
                        module-name="smsTemplate"
                        api="$resolve.api"
                       ></sms-notifications-edit>`,
        redirectTo: 'permissions-denied',
        params: {
          pageTitle: [
            '$ngRedux',
            'gettextCatalog',
            ($ngRedux, gettextCatalog) => {
              $ngRedux.dispatch(changePageTitle(gettextCatalog.getString('SMS Notification Templates')));
            },
          ],
        },
        resolve: {
          api: [
            'appFactory',
            'appApi',
            (appFactory) =>
              appFactory
                .dispatch('sms.loadDictionaries', true)
                .run()
                .then(() => ({
                  config: appFactory.deps.config,
                  showAlert: appFactory.uiHelpers.showAlert,
                  fetchTemplate: appFactory.dispatch('sms.fetchTemplate', true),
                  updateTemplate: appFactory.dispatch('sms.updateTemplate', true),
                  onLanguageSelect: appFactory.dispatch('app.toggleLanguageSelect', true),
                  initializeForm: appFactory.dispatch('app.initializeForm', true),
                  validateForm: appFactory.dispatch('app.validateForm', true),
                }))
                .catch((err) => console.error(err)),
          ],
        },
      });
    },
  ]);



// WEBPACK FOOTER //
// ./src/modules/sms/sms-component.js